import type { RootState } from '@/store'
import { ILanguage } from '@/types/task.interface'
import type {
	ISelectedPlatform,
	TPlatformValue
} from '@/types/uploadForm.interface'

export const selectSelectedPlatformByTaskId =
	(taskId: string) =>
	(state: RootState): TPlatformValue | null =>
		state.formUploader.selectedPlatformByTaskId[taskId] || null

export const selectSelectedPlatformListByTaskId =
	(taskId: string) =>
	(state: RootState): ISelectedPlatform[] =>
		state.formUploader.selectedPlatformListByTaskId[taskId] || []

export const selectOpenFormModalByTaskId =
	(taskId: string) =>
	(state: RootState): boolean =>
		state.formUploader.openFormModalByTaskId[taskId] || false

export const selectSelectedWayByTaskId =
	(taskId: string) =>
	(state: RootState): string =>
		state.formUploader.selectedWayByTaskId[taskId] || ''

export const selectSelectedTranscribingLangByTaskId =
	(taskId: string) =>
	(state: RootState): ILanguage | null =>
		state.formUploader.selectedTranscribingLangByTaskId[taskId] || null

export const selectToFollowByTaskId =
	(taskId: string) =>
	(state: RootState): boolean =>
		state.formUploader.toFollowByTaskId[taskId] || false

export const selectPendingSrtFileNameByTaskId =
	(taskId: string) =>
	(state: RootState): string =>
		state.formUploader.pendingSrtFileNameByTaskId[taskId] || ''

export const selectUploadingByTaskId =
	(taskId: string) =>
	(state: RootState): boolean =>
		state.formUploader.uploadingByTaskId[taskId] || false

export const selectTranscribingByTaskId =
	(taskId: string) =>
	(state: RootState): boolean =>
		state.formUploader.transcribingByTaskId[taskId] || false

export const selectIsGlobalUploading = (state: RootState): boolean =>
	Object.values(state.formUploader.uploadingByTaskId).some(Boolean)

export const selectIsGlobalTranscribing = (state: RootState): boolean =>
	Object.values(state.formUploader.transcribingByTaskId).some(Boolean)

export const selectUploadingFormByTaskId =
	(taskId: string) =>
	(state: RootState): boolean =>
		state.formUploader.uploadingFormByTaskId[taskId] || false

export const selectUploadedFormByTaskId =
	(taskId: string) =>
	(state: RootState): boolean =>
		state.formUploader.uploadedFormByTaskId[taskId] || false
